import { Deserializable } from '../deserializable';
import { WorldpayDataDto } from './worldpay-data-dto.model';

export class ApplicationCasePaymentDto implements Deserializable {
  public TransactionTime?: Date;
  public TransactionID?: number;
  public DueDate?: Date;
  public TotalRefunded?: number;
  public TotalRefundedValuationFee?: number;
  public TotalRefundedBookingFee?: number;
  public FeeRefunderName: string;
  public FeeRefunderCompany: string;
  public FeeRefunderDate?: Date;
  public FeeRefunderTransactionRef?: number;
  public AreFeesNotPaidInTime?: boolean;
  public IsOfflinePaid?: boolean;
  public IsOfflineRefunded?: boolean;
  public ReasonForRefund: string;
  public PaidOfflineBy: string;
  public FeesPaid: boolean;
  public WorldpayDataDto: WorldpayDataDto;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.WorldpayDataDto = new WorldpayDataDto().deserialize(input.WorldpayDataDto);
    this.FeesPaid = this.TransactionID !== null;

    return this;
  }
}
